import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=012ca694&scoped=true&"
import script from "./SearchHeader.vue?vue&type=script&lang=ts&"
export * from "./SearchHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=012ca694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ca694",
  null
  
)

export default component.exports